module.exports = __webpack_public_path__ + "img/Alyce_Currier.1de2e9f4.jpg";